import { useSyncedRef } from "@react-hookz/web";
import { useEffect, useState } from "react";

import { useInlineOutstreamAdSlotContext } from "./contexts";

// Request by Amazon to have stable div id for integration with their system
export const useInlineOutstreamAdSlotDivId = () => {
  const { acquireAdslotIndex, releaseAdslotIndex } = useInlineOutstreamAdSlotContext();
  const [index, setIndex] = useState(0);
  const syncedIndex = useSyncedRef(index);

  useEffect(() => {
    setIndex(acquireAdslotIndex());
    return () => {
      releaseAdslotIndex();
    };
  }, [acquireAdslotIndex, releaseAdslotIndex]);

  return {
    divId: `article-inline-outstream-ad-slot-${syncedIndex.current}`,
  };
};
